import VulnerabilityReportingPolicy from 'routes/VulnerabilityReportingPolicy'

export default VulnerabilityReportingPolicy
